export class ResponseError extends Error {
    responseStatus = null;

    constructor(response: any) {
        super('Response error');
        this.responseStatus = response.status;
    }
}
